import { useState } from 'react';
import { Button } from 'antd';
import { BugOutlined } from '@ant-design/icons';
import CustomTooltip from '../UI/Tooltip/CustomTooltip';
import { FeedbackModal } from './FeedbackModal';

const LABEL = 'Report a bug or share your feedback';

type Props = {
  collapsed: boolean;
};

// Sidebar entry point for the feedback modal, sitting beside the theme switcher.
const FeedbackButton = ({ collapsed }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <CustomTooltip title={LABEL} placement={collapsed ? 'right' : 'top'}>
        <Button
          type="text"
          size="small"
          aria-label={LABEL}
          icon={<BugOutlined style={{ fontSize: 16 }} />}
          className="!w-5 !h-5 !min-w-0 !p-0.5 !rounded text-neutral-900"
          onClick={() => setOpen(true)}
        />
      </CustomTooltip>
      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default FeedbackButton;
